module.exports = __webpack_public_path__ + "img/wawa_slide_3.d3bb0b90.jpg";